import type { DateRange } from "react-day-picker";
import { addDays, endOfDay, startOfDay } from "date-fns";
import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface ReportState {
  range: DateRange;
  setRange: (range?: DateRange) => void;
}

export const useReportStore = create<ReportState>()(
  devtools((set) => ({
    range: {
      from: startOfDay(new Date()),
      to: endOfDay(addDays(new Date(), 7)),
    },
    setRange: (range?: DateRange) => {
      set((state) => ({
        ...state,
        range,
      }));
    },
  })),
);
